import React, { useState } from 'react';
import { Box, Typography, Tooltip } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';

export default function VideoInfoPanel({
  title,
  views,
  likes,
  favorites,
  onLike,
  onFavorite,
  onShare,
  date,
}) {
  const [expanded, setExpanded] = useState(false)

  const handleSave = () => {
    
  }

  const formattedDate = date
    ? new Date(date * 1000).toLocaleDateString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      })
    : '';

  return (
    <Box sx={{ px: 2, py: 1,pb:0, borderBottom: 1, borderColor: 'divider' }}>
      {/* 标题区域 */}
      <Box
        onClick={() => setExpanded(!expanded)}
        sx={{
          cursor: 'pointer',
          mb: 1,
          '&:hover': { opacity: 0.9 },
        }}
      >
        <Typography
          variant="body1"
          color="text.primary"
          sx={{
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            WebkitLineClamp: expanded ? 'none' : 2,
            whiteSpace: expanded ? 'normal' : 'initial',
            lineHeight: 1.6,
            fontSize: '1rem',
            fontWeight: 600,
            transition: 'all 0.2s ease',
          }}
        >
          {title}
        </Typography>
      </Box>

      {/* 信息 + 操作按钮 */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 1,
        }}
      >
        {/* 左侧：观看数 + 时间 */}
        <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.8rem' }}>
          {views} 次观看 · {formattedDate}
        </Typography>

        {/* 右侧：操作按钮 */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            {/**
          <Tooltip title="点赞" arrow>
            <Box
              onClick={onLike}
              sx={{
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                px: 1,
                py: 0.5,
                borderRadius: 1,
                color: 'text.secondary',
                '&:hover': {
                  bgcolor: 'action.hover',
                  color: 'primary.main',
                },
              }}
            >
              <ThumbUpAltOutlined fontSize="small" />
              <Typography variant="caption" sx={{ ml: 0.5 }}>
                {likes}
              </Typography>
            </Box>
          </Tooltip>
           */}
            {/**
          <Tooltip title="收藏" arrow>
            <Box
              onClick={handleSave}
              sx={{
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                px: 1,
                py: 0.5,
                borderRadius: 1,
                color: 'text.secondary',
                '&:hover': {
                  bgcolor: 'action.hover',
                  color: 'secondary.main',
                },
              }}
            >
              <SaveIcon fontSize="small" />
            </Box>
          </Tooltip>
          
          <Tooltip title="分享" arrow>
            <Box
              onClick={onShare}
              sx={{
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                px: 1,
                py: 0.5,
                borderRadius: 1,
                color: 'text.secondary',
                '&:hover': {
                  bgcolor: 'action.hover',
                  color: 'info.main',
                },
              }}
            >
              <ShareOutlined fontSize="small" />
            </Box>
          </Tooltip>
           */}
        </Box>
      </Box>
    </Box>
  );
}
